// @flow
export const SET_DOCUMENT = 'DocumentViewer/SET_DOCUMENT';
export const CLEAR_DOCUMENT = 'DocumentViewer/CLEAR_DOCUMENT';
export const INCREASE_ZOOM = 'DocumentViewer/INCREASE_ZOOM';
export const DECREASE_ZOOM = 'DocumentViewer/DECREASE_ZOOM';

export function setDocument( doc ) {
    return {
        type: SET_DOCUMENT,
        doc: doc
    };
}

export function clearDocument() {
    return {
        type: CLEAR_DOCUMENT
    };
}

export function increaseZoom() {
    return {
        type: INCREASE_ZOOM
    }
}

export function decreaseZoom() {
    return {
        type: DECREASE_ZOOM
    }
}